/** @file ringPoint: where a ground bearing lands on the orientation cube's ground ring (px in the cube box). */
import { compassAngle } from './compassAngle';

/** The ring as drawn: camera yaw / pitch, the cube's px per half-edge and centre, the radius in half-edges. */
export type RingGeometry = { yawDeg: number; pitchDeg: number; scale: number; cx: number; cy: number; radius: number };

const RAD = Math.PI / 180;

/**
 * The ring lies on the ground plane one half-edge under the cube centre, drawn orthographically: a ground point at
 * screen angle `a` (`compassAngle`, clockwise from screen up seen from above) lands at `(r sin a, -r cos a sin pitch)`
 * from the ring centre; `k` scales the radius (labels sit outside it).
 */
export function ringPoint(g: RingGeometry, bearingDeg: number, k = 1): [number, number] {
  const cy = g.cy + Math.cos(g.pitchDeg * RAD) * g.scale;
  const r = g.radius * g.scale * k;
  const a = compassAngle(bearingDeg, g.yawDeg) * RAD;
  return [g.cx + r * Math.sin(a), cy - r * Math.cos(a) * Math.sin(g.pitchDeg * RAD)];
}
